import React, { useState, useEffect } from 'react';
import { fetchMedicationAlerts } from '../../services/medicationService';

const MedicationNotificationsTab = ({ serverId }) => {
    const [alerts, setAlerts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    
    // Filters
    const [filters, setFilters] = useState({
        missed: false,
        late: true,
        upcoming: true,
        assign_visit: true,
        stock_update: true,
        administered: true
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [showArchived, setShowArchived] = useState(false);

    useEffect(() => {
        const loadAlerts = async () => {
            try {
                setIsLoading(true);
                const data = await fetchMedicationAlerts(serverId);
                setAlerts(data);
            } catch (err) {
                console.error("Failed to load alerts", err);
            } finally {
                setIsLoading(false);
            }
        };
        loadAlerts();
    }, [serverId]);

    const toggleFilter = (key) => {
        setFilters(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const filteredAlerts = alerts.filter(alert => {
        // Archive filter
        if (!showArchived && alert.archived) return false;
        
        // Type filter
        const type = alert.alertType || 'other';
        if (filters[type] === false) return false;

        // Search
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            const hay = `${alert.notification || ''} ${alert.medicineName || ''} ${alert.userName || ''}`.toLowerCase();
            if (!hay.includes(term)) return false;
        }
        
        return true;
    });

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', alignItems: 'center' }}>
                <h2 style={{ fontSize: '20px', color: '#2d3748', margin: 0 }}>Medication Notifications</h2>
                
                <div style={{ display: 'flex', gap: '10px' }}>
                    <input 
                        type="text"
                        placeholder="Search alerts..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', minWidth: '250px' }}
                    />
                    <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px', color: '#4a5568', cursor: 'pointer' }}>
                        <input 
                            type="checkbox" 
                            checked={showArchived}
                            onChange={(e) => setShowArchived(e.target.checked)}
                            style={{ marginRight: '8px' }}
                        />
                        Show Archived
                    </label>
                </div>
            </div>

            {/* Filter Chips */}
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
                {Object.keys(filters).map(key => (
                    <button
                        key={key}
                        onClick={() => toggleFilter(key)}
                        style={{
                            padding: '6px 12px',
                            borderRadius: '16px',
                            border: `1px solid ${filters[key] ? '#3182ce' : '#e2e8f0'}`,
                            backgroundColor: filters[key] ? '#ebf8ff' : '#f7fafc',
                            color: filters[key] ? '#3182ce' : '#718096',
                            cursor: 'pointer',
                            fontSize: '13px',
                            textTransform: 'capitalize',
                            fontWeight: '500'
                        }}
                    >
                        {key.replace('_', ' ')}
                    </button>
                ))}
            </div>

            {/* Alerts List */}
            {isLoading ? (
                <div style={{ padding: '40px', textAlign: 'center', color: '#718096' }}>Loading notifications...</div>
            ) : filteredAlerts.length === 0 ? (
                <div style={{ padding: '40px', textAlign: 'center', backgroundColor: '#f7fafc', borderRadius: '8px', color: '#718096' }}>
                    No alerts match the selected filters.
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {filteredAlerts.map(alert => (
                        <div key={alert.id} style={{ 
                            padding: '16px', 
                            backgroundColor: 'white', 
                            borderRadius: '8px', 
                            border: '1px solid #e2e8f0',
                            borderLeft: `4px solid ${alert.alertType === 'missed' ? '#e53e3e' : alert.alertType === 'late' ? '#dd6b20' : '#3182ce'}`,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <div>
                                <div style={{ fontWeight: 'bold', color: '#2d3748', marginBottom: '4px' }}>
                                    {alert.userName || 'Unknown User'} - {alert.medicineName || alert.medicationName || 'Unknown Medication'}
                                </div>
                                <div style={{ fontSize: '14px', color: '#4a5568' }}>
                                    {alert.notification || 'No details provided.'}
                                </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ fontSize: '12px', color: '#718096', textTransform: 'uppercase', fontWeight: 'bold' }}>
                                    {alert.alertType}
                                </div>
                                <div style={{ fontSize: '12px', color: '#a0aec0' }}>
                                    {alert.createdAt ? new Date(alert.createdAt.seconds * 1000).toLocaleString() : 'Just now'}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MedicationNotificationsTab;
